const TAGS_AUTENTICACION_API = [
  {
    id: '#USUARIO_AUTH#',
    name: 'Usuario de la autenticación',
  },
  {
    id: '#PASSWORD_AUTH#',
    name: 'Password de la autenticación',
  },
]

export {
  TAGS_AUTENTICACION_API
}
